<template>
  <survey-chart
    :data="getChartData()"
    v-bind="$attrs"
    @click-x-axis="onXAxisClicked"
  />
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import SurveyChart from '@/components/survey/statistic/SurveyChart';
import {SurveyQuestionTypes} from '@/lib/survey-question-types';

export default {
  name: 'SurveyQuestionChart',
  components: {
    SurveyChart
  },
  mixins: [
    LocaleUtils
  ],
  props: {
    surveyQuestionStatistic: {
      required: true
    }
  },
  methods: {
    getChartData () {
      let chartData = [];

      if (this.surveyQuestionStatistic?.surveyQuestion) {
        if (this.surveyQuestionStatistic.surveyQuestion.type === SurveyQuestionTypes.TEXT) {
          chartData.push([this.trans('survey.statistic.textAnswersCount'), this.surveyQuestionStatistic?.textAnswersCount, 'ANSWERED']);
          chartData.push([this.trans('survey.statistic.noTextAnswersCount'), this.surveyQuestionStatistic?.answeredTotal - this.surveyQuestionStatistic?.textAnswersCount, 'NOT_ANSWERED']);
        } else {
          this.surveyQuestionStatistic.surveyQuestion.surveyAnswers?.forEach(answer => {
            chartData.push([answer.text, this.getCountByAnswer(answer), answer.id]);
          });

          if (this.surveyQuestionStatistic?.noAnswersSelectedCount > 0) {
            chartData.push([this.trans('survey.statistic.noAnswerSelected'), this.surveyQuestionStatistic?.noAnswersSelectedCount]);
          }
        }
      }

      return chartData;
    },

    getCountByAnswer (answer) {
      return this.surveyQuestionStatistic?.selectedAnswersCounts[answer.id] || 0;
    },

    onXAxisClicked (xIndex) {
      if (this.getChartData()[xIndex] && this.getChartData()[xIndex].length === 3) {
        this.$emit('click-answer', this.getChartData()[xIndex][2]);
      }
    }
  }
}
</script>

<style scoped>

</style>
